// PersonalInfoForm.js
import React from 'react';
import {
  FormBox,
  Title,
  InputGroup,
  Label,
  Input,
  Select,
  RadioGroup,
  RadioLabel,
  RadioInput,
  ButtonGroup,
  Button,
} from './StyledComponents';

const PersonalInfoForm = ({userInfo = {},
  isEditing,
  handleEdit,
  handleSave,
  handleChange,
  handleDelete,
  setIsEditing,
}) => {
  return (
    <FormBox>
        {/* {JSON.stringify(userInfo)} */}
      <Title>개인정보</Title>
      {/* 아이디 */}
      <InputGroup>
        <Label htmlFor="user_id">아이디</Label>
        <Input
          id="user_id"
          type="text"
          name="user_id"
          value={userInfo.user_id || ''}
          onChange={handleChange}
          disabled
        />
      </InputGroup>
      {/* 이름 */}
      <InputGroup>
        <Label htmlFor="user_name">이름</Label>
        <Input
          id="user_name"
          type="text"
          name="user_name"
          value={userInfo.user_name}
          onChange={handleChange}
          disabled={!isEditing}
        />
      </InputGroup>
      {/* 이메일 */}
      <InputGroup>
        <Label htmlFor="email_address">이메일</Label>
        <Input
          id="email_address"
          type="email"
          name="email_address"
          value={userInfo.email_address}
          onChange={handleChange}
          disabled={!isEditing}
        />
      </InputGroup>
      {/* 전화번호 */}
      <InputGroup>
        <Label htmlFor="user_mobile">전화번호</Label>
        <Input
          id="user_mobile"
          type="text"
          name="user_mobile"
          value={userInfo.user_mobile}
          onChange={handleChange}
          disabled={!isEditing}
        />
      </InputGroup>
      {/* 생년월일 */}
      <InputGroup>
        <Label htmlFor="birth_y">생년 (YYYY)</Label>
        <Input
          id="birth_y"
          type="text"
          name="birth_y"
          value={userInfo.birth_y}
          onChange={handleChange}
          disabled={!isEditing}
        />
      </InputGroup>
      <InputGroup>
        <Label htmlFor="birth_m">생월 (MM)</Label>
        {isEditing ? (
          <Select
            id="birth_m"
            name="birth_m"
            value={userInfo.birth_m}
            onChange={handleChange}
          >
            <option value="">월 선택</option>
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i} value={String(i + 1).padStart(2, '0')}>
                {i + 1}월
              </option>
            ))}
          </Select>
        ) : (
          <Input
            id="birth_m"
            type="text"
            name="birth_m"
            value={userInfo.birth_m}
            disabled
          />
        )}
      </InputGroup>
      <InputGroup>
        <Label htmlFor="birth_d">생일 (DD)</Label>
        <Input
          id="birth_d"
          type="text"
          name="birth_d"
          value={userInfo.birth_d}
          onChange={handleChange}
          disabled={!isEditing}
        />
      </InputGroup>
      {/* 성별 */}
      <InputGroup>
        <Label>성별</Label>
        {isEditing ? (
          <RadioGroup>
            <RadioLabel>
              <RadioInput
                type="radio"
                name="gender"
                value="1"
                checked={userInfo.gender === '1'}
                onChange={handleChange}
              />
              남성
            </RadioLabel>
            <RadioLabel>
              <RadioInput
                type="radio"
                name="gender"
                value="2"
                checked={userInfo.gender === '2'}
                onChange={handleChange}
              />
              여성
            </RadioLabel>
          </RadioGroup>
        ) : (
          <Input
            type="text"
            value={userInfo.gender === '1' ? '남성' : '여성'}
            disabled
          />
        )}
      </InputGroup>
      <ButtonGroup>
        {isEditing ? (
          <>
            <Button onClick={handleSave}>저장</Button>
            <Button onClick={() => setIsEditing(false)}>취소</Button>
          </>
        ) : (
          <>
            <Button onClick={handleEdit}>개인정보 수정</Button>
            <Button onClick={handleDelete}>탈퇴</Button>
          </>
        )}
      </ButtonGroup>
    </FormBox>
  );
};

export default PersonalInfoForm;
